const BANK_KEYS = ['bankName', 'bankAccount', 'bankAccountType'];

/** Billeteras y bancos Colombia — selección en app móvil (sin código bancario manual). */
export const COLOMBIAN_BANKS = [
  'Nequi',
  'Daviplata',
  'Bancolombia',
  'Banco de Bogotá',
  'Davivienda',
  'NU',
  'Banco Caja Social',
  'BBVA Colombia',
  'Banco Popular',
  'Bancamía',
  'Banco AV Villas',
  'Scotiabank Colpatria',
  'Banco de Occidente',
  'Banco Agrario',
  'Banco Falabella',
  'Lulo Bank',
  'Movii',
  'Coopcentral',
  'Bancoomeva',
  'Itaú',
  'Otro',
];

export const isDigitalWalletBank = (bankName) => {
  const n = String(bankName || '').toLowerCase();
  return ['nequi', 'daviplata', 'movii', 'lulo bank', 'nu'].some((w) => n.includes(w.replace(' bank', '')) || n === w);
};

export function getAccountHolderName(profile = {}) {
  const first = String(profile.firstName || '').trim();
  const last = String(profile.lastName || '').trim();
  return `${first} ${last}`.trim();
}

export function getAccountHolderDocument(profile = {}) {
  const type = profile.documentType || 'CC';
  const num = profile.documentId || profile.verifyId || '';
  if (!num) return '';
  return `${type} ${num}`;
}

export function hasApprovedBankDetails(profile = {}) {
  return !!(profile.bankName && profile.bankAccount);
}

export function hasPendingBankChange(profile = {}) {
  return profile.bankDetailsStatus === 'pending' && !!profile.pendingBankDetails;
}

export function bankFieldsChanged(before = {}, after = {}) {
  return BANK_KEYS.some((key) => String(before[key] || '') !== String(after[key] || ''));
}

export function getApprovedBankDetails(profile = {}) {
  if (!hasApprovedBankDetails(profile)) return null;
  return {
    bankName: profile.bankName,
    bankCode: profile.bankCode || '',
    bankAccount: profile.bankAccount,
    bankAccountType: profile.bankAccountType || 'Ahorros',
  };
}

export function getPendingBankDetails(profile = {}) {
  if (!hasPendingBankChange(profile)) return null;
  return profile.pendingBankDetails;
}

export function getEffectiveBankDetails(profile = {}) {
  return getApprovedBankDetails(profile);
}

export function buildPendingBankPayload(profile = {}, bankData = {}) {
  return {
    bankName: bankData.bankName,
    bankCode: bankData.bankCode || '',
    bankAccount: bankData.bankAccount,
    bankAccountType: bankData.bankAccountType || 'Ahorros',
    requestedAt: Date.now(),
    holderName: getAccountHolderName(profile),
    documentId: bankData.documentId || profile.documentId || profile.verifyId || '',
    documentType: bankData.documentType || profile.documentType || 'CC',
  };
}

export function canWithdrawWithBank(profile = {}) {
  if (!hasApprovedBankDetails(profile)) return false;
  if (hasPendingBankChange(profile)) {
    return true;
  }
  return profile.bankDetailsStatus !== 'pending';
}
